import {Component} from '@angular/core';
import {
  AlertController, LoadingController, ModalController, NavController, NavParams, Platform,
  ToastController, ViewController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {Storage} from "@ionic/storage";


@Component({
  selector: 'page-all-school-enquiry-reports',
  templateUrl: 'all-school-enquiry-reports.html',
})
export class AllSchoolEnquiryReportsPage {

  School = 'GEIS';
  SchoolData = {};
  Data: any;


  TotalAdm: any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public service: ServiceProvider,
              public platform: Platform,
              public loadingCtrl: LoadingController,
              public toastCtrl: ToastController,
              public storage: Storage,
              public viewCtrl: ViewController,
              public modalCtrl: ModalController,
              public alertCtrl: AlertController) {
    this.platform.ready().then(() => {

      this.SchoolData = {
        "All": 0,
        "GWW": 2,
        "GWE": 3,
        "GEIS": 1
      };

      this.loadvalues(this.SchoolData[this.School]);

    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AllSchoolEnquiryReportsPage');
  }

  active_tab(tab) {
    console.log(tab);
    this.School = tab;
    this.loadvalues(this.SchoolData[this.School]);
  }


  loadvalues(FSchoolId) {


    this.TotalAdm = [];

    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      duration: 10000
    });
    loader.present();



    this.service.httpcall('app_web_service/get_total_enquiry_report_by_school?FSchoolId='+FSchoolId).subscribe(data => {

      this.TotalAdm = data;
      console.log('TotalAdm', this.TotalAdm);
    });



    loader.dismiss();

  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues(this.SchoolData[this.School]);

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/all-school-enquiry-reports/all-school-enquiry-reports.ts